import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {get} from '../Storage';
import CircularProgress from 'material-ui/CircularProgress';
import {Message} from "mgUiKit";
import {Card, CardHeader, CardText} from 'material-ui/Card';
import WithdrawalTools from '../Page/WithdrawalTools';
import { SwitchTheme } from "mgUiKit";
// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'WidgetToolComponent';

var styles = AppSettings.styles;

class WidgetTool extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            error: false,
            showLoading: true,
            errorMessage: "",
            opened:false,
        }
        this.loadWidgetTool = this.loadWidgetTool.bind(this);
        this.socialContainerRef = React.createRef();

    }

    loadWidgetTool(event) {
        if(this.state.opened){
            this.setState({
                error: false,
                errorMessage: "",
                data: [],
                showLoading: true,
                opened:false
            });
            return;
        }
        this.setState({
            showLoading: true,
            opened:true
        });

        var url = AppSettings['env'].urlUserBoxTabControlPanel;
        axios.get(url)
            .then(({ data, status, statusText }) => {
                var showLoading = false;
                if (data.errors.length == 0) {
                    this.setState({
                        error: false,
                        showLoading: showLoading,
                        data:data.urls,
                        errorMessage: "",
                        opened:true
                    });
                } else {
                    this.setState({
                        error: true,
                        data: [],
                        showLoading: showLoading,
                        opened: true,
                        errorMessage: <KeepAlive />
                    });

                }
            })

            .catch(({ data, status, statusText }) => {
                this.setState({
                    error: true,
                    showLoading: false,
                    errorMessage: "Errore durante il caricamento",
                    opened: true,
                    data:[]
                });
            });
    }
    renderWidgetTool(){
        /*
        SMSVALIDATION
        RPT_INVOICES
        ACTIVE_ECOUPON
        REPORT_ECOUPON
        */
        if(this.state.showLoading){
            return <CircularProgress style={styles.loadingIcon}/>;
        }
        
        if(this.state.error){
            return <Message align="center">{this.state.errorMessage}</Message>;
        }
        var switchThemeAttribute = {
            on: this.state.checkedTheme,
            small:true,
            callBack: this.handleSwitchTheme.bind(this)
        };

        var clickEventModificaPassword = (e) => {
            this.context.openLinkPopup(e,AppSettings.urls.changePassword.href);
        }
        
        var urls = "";
        var filterUrl = ""; 
        if(AppSettings['isPartner']){
            //se mi trovo all'interno della dashboard non visualizzo tutti i link
            //if(typeof _dashboardPVRInstance != "undefined"){
                filterUrl = this.state.data.filter(url => (url.key.includes("ACCOUNTDATA") || url.key.includes("PERSONALDATA") || url.key.includes("VIEWMYCONTRACT")));
            //}
            //else{
            //    filterUrl = this.state.data;
            //}
        }
        else{
             filterUrl = this.state.data.filter(url => !(url.key.includes("ACTIVE_ECOUPON")));
        }
        if (filterUrl.length > 0) {
            
            urls= filterUrl.map(function (url, i) {
                //var key =url.key;
                let urlLink = url.href;
                let shareLinkContainer = "";
                let clickEvent = (e) => {
                    this.context.openLinkPopup(e, url.href);
                }
                if(url.key.toLowerCase().indexOf('sharelink') != -1){
                    urlLink = '#';
                    shareLinkContainer = <div ref={this.socialContainerRef} id="ub-share-link"></div>;
                    clickEvent = (e) => {};
                    url.target = "";
                    var self = this;
                    setTimeout(function(){
                        self.socialContainerRef.current.innerHTML = "";
                        var siteName = AppSettings["homeRealm"]
                        .replace("https://", "")
                        .replace("http://", "")
                        .replace("www.", "")
                        .replace("/", "")
                        .replace(".it", "");
                        var ShareLinkText = "Ciao, puoi registrarti su " + siteName + " cliccando sul seguente link";
                        var ShareLinkObject = "Registrati su " + siteName.toUpperCase();
                        
                        var shareBet = new Share(document.getElementById("ub-share-link"), {
                            facebook: true,
                            twitter: true,
                            print: false,
                            whatsappweb: AppSettings.device != "mobile",
                            whatsapp: true,
                            email: true,
                            telegram: true,
                            subjectText: ShareLinkObject,
                            text: ShareLinkText,
                            url: url.href,
                            hashtag: ""
                        });
                    },500);

                }
                
                //var key =url.key;
                let classes = ['mg-user-data-profile--btn'];
                classes.push(url.key);
                return (
                    <li key={i} data-key={url.key} className={classes.join(" ")}  >
                        {(url.target != undefined && url.target != "") ? 
                            <a  title={url.title} target={url.target} href={url.href}>{url.text}</a> :
                            <a  title={url.title} href={urlLink} onClick={clickEvent}>{url.text}</a> 
                        }
                        {shareLinkContainer}
                    </li>
                );
               
            }.bind(this));
        }
        else {
            return(
            <>
            <strong>Tools assenti</strong>
            </>
            )
        }
       

        return (
         <>           
            <ul className="mg-user-data-profile">
            
            {!AppSettings.mostrabtnpreleva && AppSettings['perms'].withdrawal ?
             <li className="mg-user-data-profile--btn" style={styles.noBorder}><WithdrawalTools /></li>
             : null}
                        
             <li className="mg-user-data-profile--btn">
                      <a href={AppSettings.urls.changePassword.href}  onClick={clickEventModificaPassword}>Modifica password</a>
                </li>
                {urls}
                {/* <li className="mg-user-data-profile--btn--mini" style={styles.noBorder}>
                {!AppSettings["isPartner"]?
                        <a href="/closeaccount">Chiudi Conto</a>
                       :null}
                </li> */}
            </ul>
            {AppSettings.theme.switchthemeversionenabled ? 
                            <SwitchTheme {...switchThemeAttribute} />
                        : null}
               {/* <div id="mg-user-version" style={styles.primaryBorderColor}>
                    <span className="version"> v{AppSettings.version}</span>
               </div>
             */}

            </>
    
        );
  // } 
    }
    handleSwitchTheme(theme){
        this.context.switchTheme(theme);
    }    

    render() {
        var title = <div style={styles.pointer} onClick={this.loadWidgetTool}>I tuoi strumenti</div>;
        
        return (  
            <div id="mg-tools" className="mg-user-widget">
             
                <Card containerStyle={styles.mgCardStyle} className="mg-tools" expanded={this.state.opened} onExpandChange={this.loadWidgetTool}>
                    <CardHeader titleStyle={styles.mgCardTitle}
                                subtitleStyle={styles.mgCardSubTitle}
                                title={title}
                                //subtitle={subTitle}
                                subtitle="Strumenti utili"
                                actAsExpander={false}
                                showExpandableButton={true}
                                avatar={<i className="fa-mg fa-mg-gear mg-user-icon"></i>} 

                    />
                    <CardText expandable={true} style={styles.cardText}>
                        {this.renderWidgetTool()}
                    </CardText>
                </Card>
            </div>

        );
    }
}
WidgetTool.displayName = componentName;

// PropTypes validation
WidgetTool.propTypes = {
    data: PropTypes.object.isRequired
};

// default props
WidgetTool.defaultProps = {
    data:{}
};


WidgetTool.contextTypes = {
    openLinkPopup: PropTypes.func,
    switchTheme: PropTypes.func
}
export default WidgetTool;